import {Injectable, Injector} from '@angular/core';
import {ApiService} from '../api.service';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {ErrorLoggerService} from '@services/error-logger.service';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable()
export class ByTokenActivateGuardService extends ApiService implements CanActivate {
    public tokenCheckUrl = '';

    constructor(
        http: HttpClient,
        logger: ErrorLoggerService,
        injector: Injector,
        private router: Router,
    ) {
        super(http, logger, injector);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const token = route.queryParams && route.queryParams.token ? route.queryParams.token : null;

        if (!token) {
            this.router.navigate(['/']);
            return false;
        }

        return this.get({
            url: this.tokenCheckUrl,
            id: token,
        }).pipe(
            map(() => true),
            catchError((error) => {
                this.router.navigate(['/']);
                return of(false);
            })
        );

    }
}
